/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { keysCreate } from "../funcs/keysCreate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Key } from "../models/components/key.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateAPIKeyRequest,
  CreateAPIKeySecurity,
} from "../models/operations/createapikey.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type CreateAPIKeyMutationVariables = {
  request: CreateAPIKeyRequest;
  security?: CreateAPIKeySecurity | undefined;
  options?: RequestOptions;
};

export type CreateAPIKeyMutationData = Key;

export type CreateAPIKeyMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createKey keys
 *
 * @remarks
 * Create a new api key
 */
export function useCreateAPIKeyMutation(
  options?: MutationHookOptions<
    CreateAPIKeyMutationData,
    CreateAPIKeyMutationError,
    CreateAPIKeyMutationVariables
  >,
): UseMutationResult<
  CreateAPIKeyMutationData,
  CreateAPIKeyMutationError,
  CreateAPIKeyMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildCreateAPIKeyMutation(client, options),
    ...options,
  });
}

export function mutationKeyCreateAPIKey(): MutationKey {
  return ["@gram/client", "keys", "create"];
}

export function buildCreateAPIKeyMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: CreateAPIKeyMutationVariables,
  ) => Promise<CreateAPIKeyMutationData>;
} {
  return {
    mutationKey: mutationKeyCreateAPIKey(),
    mutationFn: function createAPIKeyMutationFn({
      request,
      security,
      options,
    }): Promise<CreateAPIKeyMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(keysCreate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
